import { FileUploadStatus } from "lib/hooks/api/customer_documents/types";
import { CustomerDocumentStatus } from "lib/types/graphQLEnums";

export type UploadedDocumentRowStatus = "success" | "error" | "uploading" | "processing" | "idle";

export function getPersistedDocumentRowStatus(
  status: CustomerDocumentStatus,
): Exclude<UploadedDocumentRowStatus, "idle"> {
  if (status === CustomerDocumentStatus.Success) return "success";
  if (status === CustomerDocumentStatus.Failed) return "error";
  if (status === CustomerDocumentStatus.Uploading) return "uploading";
  return "processing";
}

export function getInFlightFileRowStatus({
  isLoading,
  fileStatus,
}: {
  isLoading: boolean;
  fileStatus: FileUploadStatus | undefined;
}): UploadedDocumentRowStatus {
  if (fileStatus?.isProcessed) return "success";
  if (fileStatus?.isError) return "error";

  if (!isLoading) return "idle";

  if (fileStatus?.isUploaded) return "processing";
  return "uploading";
}

export function getInFlightFileRowTooltip(fileStatus: FileUploadStatus | undefined) {
  if (fileStatus?.isError) return "Document upload error";
  return undefined;
}
